<template>
    <div id="app" :class="projectHost">
        <!-- SCRIPTS -->
        <noscript v-if="gtmNoscript != null"><iframe :src="'https://www.googletagmanager.com/ns.html?id=GTM-' + gtmNoscript" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
        <noscript v-if="yandexNoScript != null"><div><img :src="'https://mc.yandex.ru/watch/' + yandexNoScript" style="position:absolute; left:-9999px;" alt="" /></div></noscript>
        <!-- END SCRIPTS -->
        <vue-topprogress ref="topProgress" color="#7D7A7A" :minimum="70" :speed="450"></vue-topprogress>
        <div class="wrapper" v-if="colorIsSet && salesCard != null && saleItem != null && saleItem.project_dev_init != null && saleItem.project_dev_init != 'true'">
            <div class="wrapper-in">
                <formLandModal v-if="isOpenFormLandModal"></formLandModal>
                <AppHeader></AppHeader>
                <burgerMenu></burgerMenu>
                <main class="content">
                    <home></home>
                </main>
                <AppFooter></AppFooter>
                <topBtn :class="{fadeIn: fadeInVisible}"></topBtn>
            </div>
        </div>
        <devPage v-if="salesCard != null && salesCard.project_dev_init != null && salesCard.project_dev_init == 'true'"></devPage>
        <testThemePage v-if="projectHost == 'test-theme'"></testThemePage>
        <transition name="fade" mode="out-in">
            <div class="body-overlay" id="body-overlay" @click="closeMobileMenu(false)" v-cloak v-if="openSendwich || isOpenFormLandModal" :class="{'openFormLandModal' : isOpenFormLandModal}"></div>
        </transition>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import AppHeader from '@/components/header/header.vue'
    import AppFooter from '@/components/footer/footer.vue'
    import burgerMenu from '@/components/burger-menu/burger-menu.vue'
    import topBtn from '@/components/partials/topBtn.vue'
    import home from '@/views/home.vue'
    import devPage from '@/views/dev-page.vue'
    import testThemePage from '@/views/test-theme.vue'
    import formLandModal from '@/components/forms/form-land-modal.vue'

    import CssFilterConverter from 'css-filter-converter';
    import cookie from 'vue-cookie'

    export default {
        metaInfo() {
            if (window.host == 'zangar') {
                this.title = 'ЖИЛОЙ КОМПЛЕКС ZANGAR от BAZIS-A.';
                this.contentDescription = 'На пересечении двух столичных проспектов: Қабанбай Батыра и Ұлы Дала';
            } else if (window.host == 'aman') {
                this.title = 'AMAN – жилой комплекс от BAZIS-A в Астане';
                this.contentDescription = 'По пр. Мангилик Ел рядом с выставочным комплексом EXPO. Функциональные 1-2-3-комнатные квартиры от 32,8 до 73,5 м2. Хорошая транспортная доступность';
            } else if (window.host == 'evolution') {
                this.title = 'ЕVOLUTION от BAZIS-A в Астане';
                this.contentDescription = 'Новый жилой комплекс рядом с ТРЦ «Хан Шатыр». 1-, 2-, 3- и 4-комнатные квартиры от 47 до 126 м2. Своя жизнь в своем городе!';
            } else if (window.host == 'discovery') {
                this.title = 'DISCOVERY жилой квартал – открытие года от BAZIS-A';
                this.contentDescription = 'Жилой квартал DISCOVERY, расположенный на Аллее Тысячелетия – в квадрате улиц А. Байтурсынова и Ж. Нажимиженова, К. Азербаева и М. Жумабаева – показывает, как далеко мы можем зайти в своем стремлении познать мир и познать себя!';
            } else if (window.host == 'altyn-besik') {
                this.title = 'ALTYN BESIK от BAZIS-A в Астане';
                this.contentDescription = 'Новый ЖК на пр. Ұлы Дала, в пяти минутах от Барыс Арены. 1-3-комнатные квартиры от 35 м2. Хорошая транспортная доступность. Развитая инфраструктура.';
            } else if (window.host == 'riviera') {
                this.title = 'Жилой комплекс RIVIERA от BAZIS-A - это ваш дом у реки!';
                this.contentDescription = 'Рядом ТРК ADK. Собственный парк на набережной с терренкуром. Детский центр развития. 1-, 2-, 3-, 4-комнатные квартиры от 40 до 120 м2.';
                this.keyWordsContent = 'RIVIERA, Ривьера, ,Bazis-a, BAZIS-A, Bazis, Базис, Дом у реки, ТРК АДК, ТРК ADK, Жилой комлпекс, Алматы, Almaty';
            } else if (window.host == 'auezovcity') {
                this.title = 'Жилой комплекс AUEZOV CITY от BAZIS-A в Алматы';
                this.contentDescription = 'Начало продаж! Для вас 1- и 2-комнатные квартиры от 41 до 75 м2 на Гоголя-Ауэзова. Хорошая транспортная доступность. Развитая инфраструктура.';
                this.keyWordsContent = 'ауезов сити, алматы, ауезов сити базис-а, auezov city, жк на ауэзова от базис-а, bazis-a, almaty';
            } else if (window.host == 'alfarabi27') {
                this.title = 'Al’Farabi 27 от Bazis-A. Принадлежит только вам!';
                this.contentDescription = 'Новый жилой комплекс на Аль-Фараби-Сейфуллина. 2-3-4-комнатные квартиры от 50 до 153 м2. Рядом оздоровительный SPA & Fitness Center. Рассрочка 50/50.';
            } else if (window.host == 'primavera') {
                this.title = 'ЖИЛОЙ КОМПЛЕКС PRIMAVERA от BAZIS-A – It’s my life ';
                this.contentDescription = 'На проспекте Аль-Фараби и ул. Ходжанова. Знаковое окружение, уютные дворы, авторские лобби, видовые 1-, 2-, 3- и 4-комнатные квартиры.';
            } else if (window.host == 'estet') {
                this.title = 'ESTET – жилой комплекс в Алматы от BAZIS-A';
                this.contentDescription = 'По ул. Розыбакиева ниже пр. Аль-Фараби. Неоклассическая архитектура, огромное парковое пространство для прогулок, игр и спорта, квартиры 50–139 м2.';
            } else if (window.host == 'shahristan') {
                this.title = 'Жилой комплекс SHAHRISTAN от BAZIS-A в Шымкенте';
                this.contentDescription = 'Начало продаж! Просторные 2- и 3-комнатные квартиры от 76 до 106 м2 в новом административно-деловом центре города. Рядом с городским акиматом';
            } else if (window.host == 'soho') {
                // this.title = 'ЖИВИТЕ В СТИЛЕ SOHO2';
                // this.contentDescription = 'SOHO – это мегаполис в миниатюре от BAZIS-A! Жилые дома, школы и детские сады, развлекательные, спортивные, шопинг и бизнес-центры. Расположен по улице ханов Керея и Жанибека, напротив Президентского парка.';
            } else if (window.host == 'monaco') {
                // this.title = 'MONACO RESIDENCE | жилой комплекс от BAZIS-A';
                // this.contentDescription = '';
            } else if (window.host == 'austria') {
                this.title = 'Жилой комплекс AUSTRIA от BAZIS-A в Астане';
                this.contentDescription = 'ЕВРОПА В СЕРДЦЕ АСТАНЫ';
                this.keyWordsContent = 'Austria, Австрия, ,Bazis-a, BAZIS-A, Bazis, Базис, Европа в центре Астаны, Жилой комлпекс, Астана, Astana';
            } else if (window.host == 'landmark') {
                this.title = 'Landmark — квартал модной жизни!';
                this.contentDescription = 'Жилой квартал LANDMARK расположен в ультрамодной районе Нур-Султана, вдоль бульвара Нуржол по ул. Достык. Жить здесь значит всегда быть в курсе событий, находиться в окружении модных мест притяжения, чувствовать ритм и энергию большого города. Для вас - функциональные планировки 1-, 2-, 3-, 4-комнатных квартир от 48 до 142 м2';
                this.keyWordsContent = 'Landmark — квартал модной жизни!, жк landmark, Astana, Nur-sultan, bazis-a, bazis, базис, landmark, астана, ,базис а, Нур-султан, лэндмарк';
            } else if (window.host == 'orion-3') {
                this.title = 'ORION III - жилой комплекс от BAZIS-A';
                this.contentDescription = 'В ОКРУЖЕНИИ ПЯТИ ПАРКОВ';
            } else if (window.host == 'nurly-dala2') {
                this.title = 'Жилой район NURLY DALA 2 в Алматы';
                this.contentDescription = '1-, 2-, 3-комнатные квартиры от 35 до 59 м2. В шаге от дома новая школа. Хорошая транспортная доступность. Ипотека без залога. Удобная рассрочка';
                this.keyWordsContent = 'Nurly Dala 2, Нурлы Дала 2, Жилой район, Алматы, Almaty';
            } else if (window.host == 'satpaev') {
                this.title = 'SATPAEV – жилой комплекс от BAZIS-A в Алматы';
                this.contentDescription = '1-, 2-, 3-, 4-комнатные квартиры от 47 до 84 м2 с собственной березовой рощей. Рядом с домом новая комфортная школа';
                this.keyWordsContent = 'Satpaev, Сатпаев ЖК, Жилой комплекс, Алматы, Almaty, Базис А, Bazis';
            } else if (window.host == 'duman') {
                this.title = 'DUMAN – жилой комплекс от BAZIS-A в Атырау';
                this.contentDescription = 'Уютные квартиры на европейской стороне правого берега реки Урал. Рядом площадь Исатая и Махамбета. В шаге от дома - новая современная школа';
                this.keyWordsContent = 'Satpaev, Сатпаев ЖК, Жилой комплекс, Алматы, Almaty, Базис А, Bazis';
            } else if (window.host == 'noho') {
                this.title = 'NOHO – жилой комплекс от BAZIS-A в Астане ';
                this.contentDescription = 'Просторные 1-4-комнатные квартиры от 47 до 114 м2 напротив Президентского парка. Новая комфортная школа рядом с домом';
                this.keyWordsContent = 'Noho, нохо ЖК, Жилой комплекс, Астана, Astana, Базис А, Bazis';
            } else if (window.host == 'adamant') {
                this.title = 'ADAMANT – жилой комплекс от BAZIS-A в Астане';
                this.contentDescription = '1-, 2- и 3-комнатные квартиры по пр. Мангилик ел, напротив Центральной мечети Астаны. Рядом с домом новая комфортная школа и детский сад ';
                this.keyWordsContent = 'Adamant, Aman, аман ЖК, Жилой комплекс, Астана, Astana, Базис А, Bazis';
            } else if (window.host == 'riviera-plus') {
                this.title = 'RIVIERA PLUS – жилой комплекс от BAZIS-A в Алматы ';
                this.contentDescription = 'Квартиры вдоль реки Большая Алматинка. Сейсмостойкие дома. Прогулочный сквер с персональным выходом на набережную. Рядом школа и детский сад';
                this.keyWordsContent = 'Riviera Plus, Ривьера ЖК, Ривьера плюс, Жилой комплекс, Алматы, Almaty, Базис А, Bazis';
            } else if (window.host == 'salzburg') {
                this.title = 'SALZBURG - жилой комплекс от BAZIS-A в Астане';
                this.contentDescription = 'Впечатляющая коллекция квартир рядом с Президентским парком. Европейская архитектура. Стильный дизайн холлов до 110 м2';
                this.keyWordsContent = 'Salzburg, Зальсбург, Жилой комплекс, Астана, Astana, Базис А, Bazis';
            } else if (window.host == 'level') {
                this.title = 'LEVEL – жилой комплекс от BAZIS-A в Астане';
                this.contentDescription = '1-, 2-, 3-комнатные квартиры от 37 до 75 м2 на аллее Мынжылдык. Система контроля доступа. Face ID. Видеодомофония';
                this.keyWordsContent = 'Level, Левел, Жилой комплекс, Астана, Astana, Базис А, Bazis';
            } else if (window.host == 'jandostar') {
                this.title = 'JAN DOSTAR – жилой комплекс от BAZIS-A в Алматы';
                this.contentDescription = '1- и 2-комнатные квартиры от 36 до 66 м2 рядом с набережной реки Султанкарасу. Сейсмостойкие дома. Рядом школа и детский сад';
                this.keyWordsContent = 'Jan Dostar, Жандостар ЖК, Жилой комплекс, Алматы, Almaty, Базис А, Bazis';
            }
            return {
                title: this.title,
                meta: [
                    { name: 'description', content:  this.contentDescription},
                    { name: 'keywords', content:  this.keyWordsContent},
                ]
            };
        },
        components: {
            AppHeader,
            AppFooter,
            burgerMenu,
            home,
            devPage,
            testThemePage,
            topBtn,
            formLandModal,
        },
        data () {
            return {
                projectHost: window.host,
                isMobile: false,
                colorIsSet: false,
                themeColorMain: null,
                title: '',
                contentDescription: '',
                keyWordsContent: '',
                DomLoaded: false,
                fadeInVisible: false,
                gtmNoscript: null,
                newGtmScript: null,
                jivositeScript: null,
                yandexNoScript: null,
                lang: window.GlobalLang,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            saleItem: 'loadSaleCardItem',
            openSendwich: 'loadOpenSendwich',
            isMobileChecker: 'loadIsMobileChecker',
            isOpenFormLandModal: 'loadIsOpenFormLandModal',
        }),
        methods: {
            // getColor() {
            //     if (this.projectHost != 'yassytower') {
            //         return '#e20036'
            //     } else {
            //         return '#ab9176'
            //     }
            // },
            closeMobileMenu(data) {
                this.$store.commit('Open_Sendwich', data);
                document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
                if (this.isOpenFormLandModal) {
                    cookie.set(window.host + '_form_land_modal_timer', true, { expires: this.salesCard.project_shablon_fields.project_drop_modal_form.minutes + 'm' });
                    this.$store.commit('Open_FormLandModal', false);
                }
            },
            setNonScriptToBody() {
                // console.log(host);
                if (window.host == 'zangar') {
                    this.yandexNoScript = '93535030';
                    this.gtmNoscript = 'TBBCLJ3';
                    this.jivositeScript = 'iiHbqrb4rN';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'aman') {
                    this.yandexNoScript = '93535018';
                    this.gtmNoscript = 'W3PTQVJ';
                    this.jivositeScript = 'LJMgSjJ4Oc';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'evolution') {
                    this.yandexNoScript = '93535036';
                    this.gtmNoscript = 'TDLDZ79';
                    this.jivositeScript = 'RFt7t7IS71';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'discovery') {
                    this.yandexNoScript = '56941696';
                    this.gtmNoscript = 'P92S93Q';
                    this.jivositeScript = 'STueZFff9y';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'altyn-besik') {
                    this.yandexNoScript = '94158732';
                    this.gtmNoscript = 'KCVGJ87';
                    this.jivositeScript = '1ssn9WyU22';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'riviera') {
                    this.yandexNoScript = '53066899';
                    this.gtmNoscript = 'PLJPMV9';
                    this.jivositeScript = 'zUJv6meeuB';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'primavera') {
                    this.yandexNoScript = '76575103';
                    this.gtmNoscript = 'NBZB2B6';
                    this.jivositeScript = 'J3JGoBOlEi';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'estet') {
                    this.yandexNoScript = '94806255';
                    this.gtmNoscript = '54G7JZ7';
                    this.jivositeScript = 'Vn3U7rNx7r';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'austria') {
                    this.yandexNoScript = '76923205';
                    this.gtmNoscript = 'W6K55WQ';
                    this.jivositeScript = 'XvIyiVibeU';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'orion-3') {
                    this.yandexNoScript = '95046448';
                    this.gtmNoscript = 'PS4D74F';
                    this.jivositeScript = 'oH8ze6t5lw';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'auezovcity') {
                    this.yandexNoScript = '76923130';
                    this.gtmNoscript = 'MNPKFRS';
                    this.jivositeScript = 'HDIZFNMxyb';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'alfarabi27') {
                    this.yandexNoScript = '95046443';
                    this.gtmNoscript = 'KFSS8BX';
                    this.jivositeScript = '9XfaXY8cgD';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'shahristan') {
                    this.yandexNoScript = '76923292';
                    this.gtmNoscript = 'N56M25Z';
                    this.jivositeScript = 'vqedFDgUHA';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'soho') {
                    
                } else if (window.host == 'monaco') {
                    
                } else if (window.host == 'landmark') {
                    this.yandexNoScript = '65119945';
                    this.gtmNoscript = 'K5RFX2J';
                    this.jivositeScript = 'AKmftrrZ8Y';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'nurly-dala2' || window.host == 'nurlydala2') {
                    this.yandexNoScript = '95644716';
                    this.gtmNoscript = '5NTW2NVJ';
                    this.jivositeScript = 'i5LcEgQpfA';
                    this.addJivoToTemplate(this.jivositeScript);
                } 
                // NEW PROJECTS
                else if (window.host == 'satpaev') {
                    this.yandexNoScript = '97096578';
                    this.gtmNoscript = 'K4SQQCBX';
                    this.jivositeScript = '4DIVW1Y8sI';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'duman') {
                    this.yandexNoScript = '97130576';
                    this.gtmNoscript = 'K43G9WGT';
                    this.jivositeScript = 'p2zPqlRVYH';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'salzburg') {
                    this.yandexNoScript = '97328186';
                    this.gtmNoscript = 'MF73WCMC';
                    this.jivositeScript = 'U4j8QTUEBi';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'riviera-plus') {
                    this.yandexNoScript = '97328205';
                    this.gtmNoscript = 'K57BGH73';
                    this.jivositeScript = 'sDyh3pCKDA';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'adamant') {
                    this.yandexNoScript = '97328217';
                    this.gtmNoscript = 'PGWDV2PG';
                    this.jivositeScript = 'GAwolmzhjD';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'noho') {
                    this.yandexNoScript = '97328197';
                    this.gtmNoscript = 'T6JJK64Q';
                    this.jivositeScript = 'yebi2GsQS6';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'level') {
                    this.yandexNoScript = '97328221';
                    this.gtmNoscript = 'N6Z7GR9X';
                    this.jivositeScript = 'hqryvTby1g';
                    this.addJivoToTemplate(this.jivositeScript);
                } else if (window.host == 'jandostar') {
                    this.yandexNoScript = '97328239';
                    this.gtmNoscript = 'TD5M99XW';
                    
                } else if (window.host == 'neopark') {
                    
                } else if (window.host == 'metropole2') {
                    
                } else if (window.host == 'parkville') {
                    
                }
            },
            addJivoToTemplate(key) {
                // console.log(key);
                let externalScript = document.createElement('script')
                externalScript.setAttribute('src', '//code.jivosite.com/widget/' + key)
                // document.body.appendChild(externalScript)
                document.body.prepend(externalScript)
            },
            addNewGtmTemplate(key) {
                let externalScript = document.createElement('script')
                externalScript.setAttribute('src', 'www.googletagmanager.com/gtag/js?id=G-' + key)
                // document.body.appendChild(externalScript)
                document.body.prepend(externalScript)
            },
            setBrandColor() {
                // console.log(this.salesCard.project_shablon_fields.shablon_news_color, 'asdasdasdasdas')
                const resultBrandColor = CssFilterConverter.hexToFilter(this.salesCard.project_shablon_fields.shablon_brand_color);
                const resultLogoBazisColor = CssFilterConverter.hexToFilter(this.salesCard.project_shablon_fields.shablon_logo_bazis_color);
                document.body.style.setProperty('--shablon-color', this.salesCard.project_shablon_fields.shablon_brand_color);
                document.body.style.setProperty('--shablon-plans-color', this.salesCard.project_shablon_fields.shablon_plans_color);
                document.body.style.setProperty('--shablon-news-color', this.salesCard.project_shablon_fields.shablon_news_color);
                document.body.style.setProperty('--shablon-logo-bazis-color', resultLogoBazisColor.color);
                document.body.style.setProperty('--shablon-pin-icon-filter-color', resultBrandColor.color);
                this.themeColorMain = this.salesCard.project_shablon_fields.shablon_brand_color;
                this.colorIsSet = true;
                // console.log(result, 'asdasdasda')
            },
            checkFormLandModal() {
                if (this.salesCard != null) {
                    if (this.salesCard.project_shablon_fields.project_drop_modal_form != undefined && this.salesCard.project_shablon_fields.project_drop_modal_form.init == 'true') {
                        // console.log(this.salesCard.project_shablon_fields, 'asdasdasdsa')
                        const seconds = parseInt(this.salesCard.project_shablon_fields.project_drop_modal_form.seconds) * 1000;
                        var timerCockie = cookie.get(window.host + '_form_land_modal_timer');
                        setTimeout(() => {
                            // console.log(seconds);
                            if (timerCockie == null) {
                                // console.log(seconds, 'SECONDS', timerCockie);
                                this.$store.commit('Open_FormLandModal', true);
                                document.getElementsByTagName('body')[0].classList.add('overlay-open');
                            } 
                            // else { // если кука есть какие то действия при необходимости
                            //     console.log(timerCockie, 'COCKIE TIMER');
                            // }
                        }, seconds);
                    } 
                    // else {
                    //     // console.log('FORM LAND MODAL IS FFFFFALLLLLLSEEEEE ')
                    // }
                }

                // const tokenAuthCrm = cookie.get('crm_auth_token');
                // cookie.set('crm_auth_token', response.data.access_token, { expires: response.data.expires_in + 's' });
                // isOpenFormLandModal
                // Open_FormLandModal
            },
            // MOBILE CHECKER
            isMobileCheck() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                    this.$store.commit('setMobileCheckerState', true);
                    this.$store.commit('setOffsetResponse', -60);
                }
            },
            handleResize() {
                if (window.innerWidth < 767) {
                    this.iSmobile = true
                    this.$store.commit('setMobileCheckerState', true);
                    this.$store.commit('setOffsetResponse', -60);
                } else {
                    this.iSmobile = false
                    this.$store.commit('setMobileCheckerState', false);
                    this.$store.commit('setOffsetResponse', -100);
                }
            },
            checkResize() {
                window.addEventListener('resize', this.handleResize)
                this.handleResize();
            },
            handleScroll () {
                if (window.scrollY >= window.innerHeight - 600) {
                    this.fadeInVisible = true;
                } else {
                    this.fadeInVisible = false;
                }
            },
        },
        beforeCreate() {
            if (localStorage.getItem('language') === null) {
                localStorage.setItem('language', '');
            }
            if (window.host == 'localhost:8080' || window.host == 'localhost:8081' || window.host == 'localhost:8082') { // DEV VAR // DEV VAR // DEV VAR // DEV VAR // DEV VAR // DEV VAR // DEV VAR // DEV VAR // DEV VAR // DEV VAR // DEV VAR //
                window.host = 'primavera';
            } else if (window.host == 'test-shablon') { // TEST PAGE VAR
                window.host = 'test-theme'
            } else if (window.host == 'auezov-city') {
                window.host = 'auezovcity'
            } else if (window.host == 'soho') {
                window.host = 'soho2'
            } else if (window.host == 'orion-iii') {
                window.host = 'orion-iii'
            } else if (window.host == 'nurlydala') {
                window.host = 'nurly-dala2'
            } else if (window.host == 'nurlydala2') {
                window.host = 'nurly-dala2'
            } else if (window.host == 'jandostar') {
                window.host = 'jandostar'
            }
            document.querySelector('body').setAttribute('data-project', window.host);
            document.body.classList.add(window.host);
            this.$store.dispatch('getCrmAuthToken').then((response) => {
                this.$store.dispatch('getContactsPageData');
                this.$store.dispatch('getFlatsPageData');
                this.$store.dispatch('getSalesCardPageData');
                this.$store.dispatch('getSaleItemFiltersParams', window.host);
                this.$store.dispatch('getSaleItemCard', window.host);
                this.$store.dispatch('getSalesCardContent', window.host);
            });
        },
        created () {
            this.setNonScriptToBody();
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        mounted() {
            this.isMobileCheck();
            this.checkResize();
            this.$refs.topProgress.start();
            this.$store.watch(
                (state) => state.salesCardContent,
                (newValue) => {
                    if (newValue != null) {
                        this.setBrandColor();
                        this.checkFormLandModal();
                        this.$refs.topProgress.done();
                    }
                }
            )
        }
    }
</script>

<style>
.grecaptcha-badge {
    opacity: 0 !important;
    visibility: hidden;
}
</style>